import React, { Component } from 'react';
import Route from 'react-router-dom/Route';
import { AnimatedSwitch } from 'react-router-transition'

import Home from '../pages/Home'
import Work from '../pages/Work'
import Single from '../pages/Single'
import About from '../pages/About'
import Projects from '../pages/Projects'
import Notfound from '../pages/Notfound'

/// we need to map the `scale` prop we define below
// to the transform style property
function mapStyles(styles) {
  return {
    opacity: styles.opacity,
    transform: `translateY(${styles.y}%)`,
  };
}



// child matches will...
const bounceTransition = {
  // start in a transparent, upscaled state
  atEnter: {
    opacity: 0,
    y: 0,
  },
  // leave in a transparent, downscaled state
  atLeave: {
    opacity: 0,
    y: 0,
  },
  // and rest at an opaque, normally-scaled state
  atActive: {
    opacity: 1,
    y: 0,
  },
};



class Main extends Component {
  render() {
    return (
      <main className="main-wrapper">

     
      
      <AnimatedSwitch
        atEnter={bounceTransition.atEnter}
        atLeave={bounceTransition.atLeave}
        atActive={bounceTransition.atActive}
        mapStyles={mapStyles}
        className="route-wrapper"
      >
          <Route exact path='/' component={Home}/>
          <Route exact path='/work' component={Work}/>
          <Route exact path='/projects' component={Projects}/>
          <Route exact path='/about' component={About}/>
          <Route path='/work/:slug' component={Single}/>
          <Route component={Notfound}/>
        </AnimatedSwitch>
      
    </main>
    );
  }
}

export default Main;




// WEBPACK FOOTER //
// ./src/components/Main.js